/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { FormDefinitionWrapper, NIFormData } from './form/services';
import { createStyles, ListItem, ListItemIcon, ListItemText, Theme, withStyles, WithStyles } from "@material-ui/core";
import CloudQueueIcon from "@material-ui/icons/CloudQueue";
import moment from "moment";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { AppState, FollowUp, openFollowUpEditor } from "../../redux";
import { getListItemValues } from "../../utils/interface";
import { momentShortFormat } from "../../utils/time";

moment.updateLocale("en", momentShortFormat);

const styles = (theme: Theme) =>
  createStyles({
    listing: {
      backgroundColor: "#fff",
      // padding: theme.spacing(1),
      elevation: 2,
    },
    moreButton: {
      color: theme.palette.divider,
      "&:hover": {
        color: theme.palette.text.secondary,
      },
    },
  });

interface FollowUpListItemProps extends WithStyles<typeof styles> {
  facilityId: string;
  followUp: FollowUp;
  form: FormDefinitionWrapper;
}

export default withStyles(styles)((props: FollowUpListItemProps) => {
    const { facilityId, followUp, form } = props;

    const visitData: NIFormData | null = useSelector((state: AppState) => state.followUps.visits.get(followUp.data.id) ?? null);

    const isDirty = visitData !== null && Object.keys(visitData).length > 0;

    const { primary, secondary } = useMemo(
      () => getListItemValues({
        visit: visitData,
        actionPlan: followUp.data,
      }, form),
      [followUp, form, visitData]
    );

    const dispatch = useDispatch();
    const history = useHistory();

    function handleClick() {
      dispatch(openFollowUpEditor(facilityId, followUp.data.id, history));
    }

    return !form ? null : (
      <ListItem button onClick={handleClick}>
        {isDirty && (
          <ListItemIcon>
            <CloudQueueIcon />
          </ListItemIcon>
        )}
        <ListItemText primary={primary} secondary={secondary} />
      </ListItem>
    );
  });
